module.exports = __webpack_public_path__ + "img/69.275c0692.png";